import VueRouter from 'vue-router'
import Page from '@/components/Page'
import Artwork from '@/components/Artwork'
import Login from '@/components/Login'
import Member from '@/components/Member'
import axios from 'axios'
import i18n from './i18n'
import Root from '@/components/Root'
import Post from '@/components/Post'

export const routes = [
  {
    path: "/",
    redirect: i18n.locale
  },
  {
    path: '/:lang(en|fr)',
    component: Root,
    children: [
      {
        path: '',
        name: 'Home',
        component: Page,
        props: true
      },
      {
        path: 'artwork/:id',
        name: 'Artwork',
        component: Artwork
      },
      {
        path: 'login',
        name: 'Login',
        component: Login
      },
      {
        path: 'member/:path?',
        name: 'Member',
        component: Member,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: ':year/:month/:day/:slug',
        name: 'Post',
        component: Post,
        props: true
      },
      {
        path: ':path*',
        name: 'Page',
        component: Page,
        alias: '',
        props: true
      },
      {
        path: '*',
        name: 'PageNotFound',
        redirect: 'notfound'
      }
    ]
  }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeResolve((to, from, next) => {
  const lang = to.params.lang

  if (!['en', 'fr'].includes(lang)) return next('en')

  if (i18n.locale !== lang) {
    i18n.locale = lang
  }

  // return next()

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // check if user is logged in otherwise redirect to login page
    axios.post(process.env.VUE_APP_API_URL_EN + "wp-json/jwt-auth/v1/token/validate", null, {
      headers: {Authorization: 'Bearer ' + localStorage.token}
    }).then (response => {
      if (response.status === 200) {
        next()
      }
      else {
        next({
          name: 'Login'
        })
      }
    }).catch(function () {
      next({
        name: 'Login'
      })
    })
  } else {
    next()
  }
})

export default router